// Module
var code = "<div class=\"form-group-container\"> <div id=\"mb-object-type-form\"></div> <div class=\"mb-go-to-component card\"> <button class=\"btn waves-effect waves-light\">Go to component in flow</button> </div> </div> ";
// Exports
export default code;